<template>
  <div id="people" class="mdc-layout-grid mdc-container">
    <section class="row order-md-1 text-center text-md-left">
      <div class="col-md-7">
        <h2
          data-aos="fade-in"
          data-aos-easing="linear"
          data-aos-duration="1000"
          class="mdc-typography--headline3 font-weight-bold"
        >
          {{ $t('hero_title') }}
        </h2>
        <p
          data-aos="fade-in"
          data-aos-easing="linear"
          data-aos-delay="800"
          data-aos-duration="1000"
          class="mdc-typography--headline5"
        >
          {{ $t('hero_description') }}
        </p>
      </div>
      <div
        class="col-md-5 d-flex justify-content-md-end justify-content-center"
        data-aos="fade-in"
        data-aos-easing="linear"
        data-aos-delay="3000"
        data-aos-duration="2000"
      >
        <iframe
          src="https://discordapp.com/widget?id=695968301439909900&theme=dark"
          width="350"
          height="500"
          allowtransparency="true"
          frameborder="0"
          sandbox="allow-popups allow-popups-to-escape-sandbox allow-same-origin allow-scripts"
        ></iframe>
      </div>
    </section>
    <section class="col-lg-6 p-lg-0">
      <div class="row pb-lg-4">
        <div class="search-wrapper panel-heading col-lg-6 col-sm-12">
          <input
            class="form-control"
            type="text"
            v-model="searchQuery"
            placeholder="Search People"
          />
        </div>
      </div>
      <h3 class="mdc-typography--headline3 font-weight-bold">
        {{ $t('art') }}
      </h3>
      <dd v-if="!resultQuery.length">{{ $t('empty') }} '{{ searchQuery }}'</dd>
      <dl v-for="person in resultQuery.slice().reverse()" :key="person.id">
        <div class="px-3 pt-lg-1" v-if="person.role == 'art'">
          <dt class="mdc-typography--headline6">{{ person.name }}</dt>
          <dd>{{ person.job_title }}</dd>
          <dd>{{ person.short_bio }}</dd>
          <dd>{{ person.since }}</dd>
        </div>
      </dl>

      <h3 class="mdc-typography--headline3 font-weight-bold">
        {{ $t('audio') }}
      </h3>
      <dd v-if="!resultQuery.length">{{ $t('empty') }} '{{ searchQuery }}'</dd>
      <dl v-for="person in resultQuery.slice().reverse()" :key="person.id">
        <div class="px-3 pt-lg-1" v-if="person.role == 'audio'">
          <dt class="mdc-typography--headline6">{{ person.name }}</dt>
          <dd>{{ person.job_title }}</dd>
          <dd>{{ person.short_bio }}</dd>
          <dd>{{ person.since }}</dd>
        </div>
      </dl>

      <h3 class="mdc-typography--headline3 font-weight-bold">
        {{ $t('business') }}
      </h3>
      <dd v-if="!resultQuery.length">{{ $t('empty') }} '{{ searchQuery }}'</dd>
      <dl v-for="person in resultQuery.slice().reverse()" :key="person.id">
        <div class="px-3 pt-lg-1" v-if="person.role == 'business'">
          <dt class="mdc-typography--headline6">{{ person.name }}</dt>
          <dd>{{ person.job_title }}</dd>
          <dd>{{ person.short_bio }}</dd>
          <dd>{{ person.since }}</dd>
        </div>
      </dl>

      <h3 class="mdc-typography--headline3 font-weight-bold">
        {{ $t('support') }}
      </h3>
      <dd v-if="!resultQuery.length">{{ $t('empty') }} '{{ searchQuery }}'</dd>
      <dl v-for="person in resultQuery.slice().reverse()" :key="person.id">
        <div class="px-3 pt-lg-1" v-if="person.role == 'support'">
          <dt class="mdc-typography--headline6">{{ person.name }}</dt>
          <dd>{{ person.job_title }}</dd>
          <dd>{{ person.short_bio }}</dd>
          <dd>{{ person.since }}</dd>
        </div>
      </dl>

      <h3 class="mdc-typography--headline3 font-weight-bold">
        {{ $t('data-science') }}
      </h3>
      <dd v-if="!resultQuery.length">{{ $t('empty') }} '{{ searchQuery }}'</dd>
      <dl v-for="person in resultQuery.slice().reverse()" :key="person.id">
        <div class="px-3 pt-lg-1" v-if="person.role == 'data-science'">
          <dt class="mdc-typography--headline6">{{ person.name }}</dt>
          <dd>{{ person.job_title }}</dd>
          <dd>{{ person.short_bio }}</dd>
          <dd>{{ person.since }}</dd>
        </div>
      </dl>

      <h3 class="mdc-typography--headline3 font-weight-bold">
        {{ $t('hr') }}
      </h3>
      <dd v-if="!resultQuery.length">{{ $t('empty') }} '{{ searchQuery }}'</dd>
      <dl v-for="person in resultQuery.slice().reverse()" :key="person.id">
        <div class="px-3 pt-lg-1" v-if="person.role == 'hr'">
          <dt class="mdc-typography--headline6">{{ person.name }}</dt>
          <dd>{{ person.job_title }}</dd>
          <dd>{{ person.short_bio }}</dd>
          <dd>{{ person.since }}</dd>
        </div>
      </dl>

      <h3 class="mdc-typography--headline3 font-weight-bold">
        {{ $t('design') }}
      </h3>
      <dd v-if="!resultQuery.length">{{ $t('empty') }} '{{ searchQuery }}'</dd>
      <dl v-for="person in resultQuery.slice().reverse()" :key="person.id">
        <div class="px-3 pt-lg-1" v-if="person.role == 'design'">
          <dt class="mdc-typography--headline6">{{ person.name }}</dt>
          <dd>{{ person.job_title }}</dd>
          <dd>{{ person.short_bio }}</dd>
          <dd>{{ person.since }}</dd>
        </div>
      </dl>

      <h3 class="mdc-typography--headline3 font-weight-bold">
        {{ $t('software') }}
      </h3>
      <dd v-if="!resultQuery.length">{{ $t('empty') }} '{{ searchQuery }}'</dd>
      <dl v-for="person in resultQuery.slice().reverse()" :key="person.id">
        <div class="px-3 pt-lg-1" v-if="person.role == 'software'">
          <dt class="mdc-typography--headline6">{{ person.name }}</dt>
          <dd>{{ person.job_title }}</dd>
          <dd>{{ person.short_bio }}</dd>
          <dd>{{ person.since }}</dd>
        </div>
      </dl>

      <h3 class="mdc-typography--headline3 font-weight-bold">
        {{ $t('infrastructure') }}
      </h3>
      <dd v-if="!resultQuery.length">{{ $t('empty') }} '{{ searchQuery }}'</dd>
      <dl v-for="person in resultQuery.slice().reverse()" :key="person.id">
        <div class="px-3 pt-lg-1" v-if="person.role == 'infrastructure'">
          <dt class="mdc-typography--headline6">{{ person.name }}</dt>
          <dd>{{ person.job_title }}</dd>
          <dd>{{ person.short_bio }}</dd>
          <dd>{{ person.since }}</dd>
        </div>
      </dl>

      <h3 class="mdc-typography--headline3 font-weight-bold">
        {{ $t('writing') }}
      </h3>
      <dd v-if="!resultQuery.length">{{ $t('empty') }} '{{ searchQuery }}'</dd>
      <dl v-for="person in resultQuery.slice().reverse()" :key="person.id">
        <div class="px-3 pt-lg-1" v-if="person.role == 'writing'">
          <dt class="mdc-typography--headline6">{{ person.name }}</dt>
          <dd>{{ person.job_title }}</dd>
          <dd>{{ person.short_bio }}</dd>
          <dd>{{ person.since }}</dd>
        </div>
      </dl>

      <h3 class="mdc-typography--headline3 font-weight-bold">
        {{ $t('experts') }}
      </h3>
      <dd v-if="!resultQuery.length">{{ $t('empty') }} '{{ searchQuery }}'</dd>
      <dl v-for="person in resultQuery.slice().reverse()" :key="person.id">
        <div class="px-3 pt-lg-1" v-if="person.role == 'experts'">
          <dt class="mdc-typography--headline6">{{ person.name }}</dt>
          <dd>{{ person.job_title }}</dd>
          <dd>{{ person.short_bio }}</dd>
          <dd>{{ person.since }}</dd>
        </div>
      </dl>
    </section>
  </div>
</template>

<script>
export default {
  name: 'People',
  metaInfo() {
    return {
      title: this.$t('title') || 'Default',
      titleTemplate: '%s | Surfverse',
      meta: [{ name: 'description', content: this.$t('description') }]
    }
  },
  data: function() {
    return {
      searchQuery: null,
      people: [
        {
          name: this.$t('person1.name'),
          categoryName: 'software',
          role: 'software',
          job_title: this.$t('person1.job_title'),
          short_bio: this.$t('person1.bio'),
          since: this.$t('person1.since'),
          tags: [
            this.$t('person1.skills.1'),
            this.$t('person1.skills.2'),
            this.$t('person1.skills.3')
          ]
        },
        {
          name: this.$t('person2.name'),
          categoryName: 'art',
          role: 'art',
          job_title: this.$t('person2.job_title'),
          short_bio: this.$t('person2.bio'),
          since: this.$t('person2.since'),
          tags: [
            this.$t('person2.skills.1'),
            this.$t('person2.skills.2'),
            this.$t('person2.skills.3')
          ]
        },
        {
          name: this.$t('person3.name'),
          categoryName: 'art',
          role: 'art',
          job_title: this.$t('person3.job_title'),
          short_bio: this.$t('person3.bio'),
          since: this.$t('person3.since'),
          tags: [
            this.$t('person3.skills.1'),
            this.$t('person3.skills.2'),
            this.$t('person3.skills.3')
          ]
        }
      ]
    }
  },
  computed: {
    resultQuery() {
      if (this.searchQuery) {
        return this.people.filter(item => {
          return this.searchQuery
            .toLowerCase()
            .split(' ')
            .every(v => item.name.toLowerCase().includes(v))
        })
      } else {
        return this.people
      }
    }
  }
}
</script>
<i18n>
{
  "en": {
    "title": "People at Surfverse",
    "description": "Connect with friends, family and other people you know. Share photos and videos, send messages and get updates.",
    "hero_title": "Boss-free since 2017. 🖕",
    "hero_description": "We believe that the best product decisions are made by the people who are actually doing the work. We take great pride in hiring top talent from a variety of disciplines and bringing people together with one simple directive: Collaborate and create. Below are some of the people at Surfverse who do just that. And to the right is our Discord Community. Join Us.",
    "mission": "Supporting future",
    "vision": "",
    "scope": "",
    "art": "Art",
    "audio": "Audio",
    "business": "Business Development",
    "support": "Customer Support",
    "data-science": "Data Science",
    "hr": "Human Resources",
    "design": "Product Design",
    "software": "Software Engineering",
    "infrastructure": "Technical Infrastructure",
    "writing": "Writing",
    "experts": "Other Experts",
    "empty": "We didn't find anyone whose name begins with",
    "person1": {
      "name": "Bogdan Mateescu",
      "job_title": "Founder & CEO",
      "bio": "Bogdan held many roles in the organization, from Software Engineering to Design.",
      "description": "This is the long description i ever wrote about. Lorem ipsum dolor sit amet consecteur.",
      "since": "07/30/2017",
      "skills": {
        "1": "Software Developer",
        "2": "Designer",
        "3": "DevOps"
      }
    },
    "person2": {
      "name": "Matei",
      "job_title": "Co-Founder & Manager",
      "bio": "Something about me",
      "description": "This is the long description i ever wrote about. Lorem ipsum dolor sit amet consecteur.",
      "since": "07/30/2017",
      "skills": {
        "1": "Software Developer",
        "2": "Designer",
        "3": "DevOps"
      }
    },
    "person3": {
      "name": "Bogdan",
      "job_title": "Human Resurces",
      "bio": "Something about me",
      "description": "This is the long description i ever wrote about. Lorem ipsum dolor sit amet consecteur.",
      "since": "07/30/2017",
      "skills": {
        "1": "Software Developer",
        "2": "Designer",
        "3": "DevOps"
      }
    }
  },
  "ro": {
    "title": "Oameni la Surfverse",
    "description": "Gaseste prieteni, fondatori si vezi ce e nou in lumea startup-urilor",
    "hero_title": "Fără șefi din 2017. 🖕",
    "hero_description": "Credem că cele mai bune decizii de produs sunt luate de oamenii care efectiv lucrează la ele. Ne mândrim cu angajarea de talente de top dintr-o varietate de discipline și aducem oamenii împreună sub o directivă simplă: Colaborați și creați. Mai jos sunt câteva dintre persoanele de la Surfverse care fac exact asta, iar în dreapta este comunitatea noastră pe Discord. Vizitează-ne și acolo.",
    "mission": "Sprijinim viitorii antreprenori în călătoria lor de a remodela lumea.",
    "art": "Artă",
    "audio": "Audio",
    "business": "Dezvoltarea Afacerii",
    "support": "Relații Clienți",
    "data-science": "Știința Datelor",
    "hr": "Resurse Umane",
    "design": "Design de produs",
    "software": "Inginerie Software",
    "infrastructure": "Infrastructură Tehnică",
    "writing": "Scriitori",
    "experts": "Alți experți",
    "empty": "Nu am găsit pe nimeni al cărui nume să înceapă cu"
  },
  "de": {
    "title": "About Us",
    "description": "Deutch in germana",
    "mission": "Sprijinim viitorii antreprenori în călătoria lor de a remodela lumea."
  }
}
</i18n>

<style>
#people {
  margin-top: 150px;
}
</style>
